{
  "0": {
    "workSheet": {
      "conditionalFormattings": [],
      "headerFooter": null,
      "id": 1,
      "name": "data",
      "pageSetup": {
        "fitToPage": false,
        "margins": {
          "left": 0.7,
          "right": 0.7,
          "top": 0.75,
          "bottom": 0.75,
          "header": 0.3,
          "footer": 0.3
        },
        "orientation": "portrait",
        "horizontalDpi": 4294967295,
        "verticalDpi": 4294967295,
        "pageOrder": "downThenOver",
        "blackAndWhite": false,
        "draft": false,
        "cellComments": "None",
        "errors": "displayed",
        "scale": 100,
        "fitToWidth": 1,
        "fitToHeight": 1,
        "firstPageNumber": 1,
        "useFirstPageNumber": true,
        "usePrinterDefaults": false,
        "copies": 1
      },
      "properties": {
        "defaultRowHeight": 17,
        "dyDescent": 0,
        "outlineLevelRow": 0,
        "outlineLevelCol": 0,
        "defaultColWidth": 8.83203125
      },
      "rowBreaks": [],
      "state": "visible",
      "tables": {},
      "views": [
        {
          "workbookViewId": 0,
          "rightToLeft": false,
          "state": "normal",
          "showRuler": true,
          "showRowColHeaders": true,
          "showGridLines": true,
          "zoomScale": 100,
          "zoomScaleNormal": 100,
          "activeCell": "I19"
        }
      ]
    },
    "colValidations": {},
    "rowLayouts": [
      {
        "number": 1,
        "style": {},
        "height": 20
      },
      {
        "number": 2,
        "style": {}
      },
      {
        "number": 3,
        "style": {},
        "height": 30
      },
      {
        "number": 4,
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "height": 30
      },
      {
        "number": 5,
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "height": 17
      },
      {
        "number": 6,
        "style": {}
      },
      {
        "number": 7,
        "style": {},
        "height": 30
      },
      {
        "number": 9,
        "style": {}
      }
    ],
    "colLayouts": [
      {
        "width": 2.6,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "A",
        "number": 1
      },
      {
        "width": 18,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "B",
        "number": 2
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "C",
        "number": 3
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "D",
        "number": 4
      },
      {
        "width": 32,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "E",
        "number": 5
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "F",
        "number": 6
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "G",
        "number": 7
      },
      {
        "width": 18,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "H",
        "number": 8
      },
      {
        "width": 12.8,
        "style": {
          "numFmt": "#,##0_ ;[Red]-#,##0 "
        },
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "I",
        "number": 9
      }
    ],
    "cellDatas": [
      {
        "address": "B2",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": "사용자 정보",
        "col": 2,
        "row": 2
      },
      {
        "address": "B3",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "사용자 명",
        "col": 2,
        "row": 3
      },
      {
        "address": "C3",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 3,
        "row": 3
      },
      {
        "address": "D3",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "사용자 ID",
        "col": 4,
        "row": 3
      },
      {
        "address": "E3",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 5,
        "row": 3
      },
      {
        "address": "F3",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "부서",
        "col": 6,
        "row": 3
      },
      {
        "address": "G3",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 7,
        "row": 3
      },
      {
        "address": "B4",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "사원 번호",
        "col": 2,
        "row": 4
      },
      {
        "address": "C4",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 3,
        "row": 4
      },
      {
        "address": "D4",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "직위",
        "col": 4,
        "row": 4
      },
      {
        "address": "E4",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 5,
        "row": 4
      },
      {
        "address": "F4",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle",
            "wrapText": true
          }
        },
        "value": "직책",
        "col": 6,
        "row": 4
      },
      {
        "address": "G4",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 7,
        "row": 4
      },
      {
        "address": "H4",
        "style": {
          "numFmt": "#,##0_ ;[Red]-#,##0 ",
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 8,
        "row": 4
      },
      {
        "address": "H5",
        "style": {
          "numFmt": "#,##0_ ;[Red]-#,##0 ",
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 8,
        "row": 5
      },
      {
        "address": "B6",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": "검색 조건",
        "col": 2,
        "row": 6
      },
      {
        "address": "B7",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "포인트 정보",
        "col": 2,
        "row": 7
      },
      {
        "address": "C7",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 3,
        "row": 7
      },
      {
        "address": "D7",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "시작 기간",
        "col": 4,
        "row": 7
      },
      {
        "address": "E7",
        "style": {
          "numFmt": "mm-dd-yy",
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 5,
        "row": 7
      },
      {
        "address": "F7",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "종료 기간",
        "col": 6,
        "row": 7
      },
      {
        "address": "G7",
        "style": {
          "numFmt": "mm-dd-yy",
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 7,
        "row": 7
      },
      {
        "address": "B9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "날짜",
        "col": 2,
        "row": 9
      },
      {
        "address": "C9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "사용자명",
        "col": 3,
        "row": 9
      },
      {
        "address": "D9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "정책그룹명",
        "col": 4,
        "row": 9
      },
      {
        "address": "E9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "정책명",
        "col": 5,
        "row": 9
      },
      {
        "address": "F9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "타입",
        "col": 6,
        "row": 9
      },
      {
        "address": "G9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "argb": "FF000000"
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "argb": "FF000000"
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "지급사유",
        "col": 7,
        "row": 9
      },
      {
        "address": "H9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "argb": "FF000000"
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "argb": "FF000000"
            }
          },
          "alignment": {
            "horizontal": "left",
            "vertical": "middle"
          }
        },
        "value": "만료일시",
        "col": 8,
        "row": 9
      },
      {
        "address": "I9",
        "style": {
          "numFmt": "#,##0_ ;[Red]-#,##0 ",
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "right",
            "vertical": "middle"
          }
        },
        "value": "금액",
        "col": 9,
        "row": 9
      }
    ],
    "images": []
  },
  "workbook": {
    "created": "2024-12-10T02:20:17.000Z",
    "creator": "",
    "lastModifiedBy": "",
    "modified": "2024-12-17T05:49:35.000Z",
    "views": [
      {
        "x": 0,
        "y": 500,
        "width": 35840,
        "height": 20620,
        "visibility": "visible"
      }
    ],
    "properties": {
      "date1904": false
    }
  }
}
